import cxs from 'cxs';
import { COLOURS } from '../../../../../common/styles/vars';

export const FILTERS_CONTAINER = ({
  isMobile,
  alignSearchRight



}) => cxs({
  alignItems: 'center',
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  justifyContent: !alignSearchRight ? 'space-between' : 'flex-end',
  width: '100%',
  height: isMobile ? void 0 : '110px'
});

export const SEARCH_CLS = (
{
  isMobile,
  alignSearchRight,
  hideSearchFilter




}) =>
cxs({
  maxWidth: '400px',
  marginRight: !hideSearchFilter && '20px',
  width: isMobile ? '100%' : void 0,
  flex: !alignSearchRight ? '1' : void 0
});

export const DROPDOWN_CLS = cxs({
  minWidth: '185px'
});

export const RIGHT_CONTENT_CLS = cxs({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',

  '> *:not(:last-child)': {
    marginRight: '20px'
  }
});

export const FILTER_TOGGLE_CONTAINER = cxs({
  position: 'relative',
  maxWidth: '40px'
});

export const FILTER_TOGGLE = cxs({
  maxWidth: '40px',
  minWidth: '40px'
});

export const FILTERS_MOBILE = cxs({
  boxSizing: 'border-box',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between'
});

export const FILTERS_MOBILE_ICONS_CONTAINER = cxs({
  display: 'flex',

  '> .icon-container:first-child': {
    marginRight: '20px'
  }
});

export const BADGE = cxs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '15px',
  height: '15px',
  backgroundColor: COLOURS.cyan.aqua,
  borderRadius: '50%',
  position: 'absolute',
  top: '-8px',
  right: '-4px',
  textAlign: 'center'
});